import z from "zod";

import {
  addConditionActionSchema,
  addEffectActionSchema,
  addHandlerActionSchema,
  addResponseActionSchema,
  addTriggerActionSchema,
  addTriggerCaseActionSchema,
  moveConditionActionSchema,
  removeConditionActionSchema,
  removeEffectActionSchema,
  removeHandlerActionSchema,
  removeAllTriggersActionSchema,
  removeResponseActionSchema,
  removeTriggerActionSchema,
  removeTriggerCaseActionSchema,
  reorderConditionActionSchema,
  reorderEffectActionSchema,
  reorderHandlerActionSchema,
  reorderResponseActionSchema,
  reorderTriggerActionSchema,
  updateConditionConfigActionSchema,
  updateEffectConfigActionSchema,
  updateHandlerActionSchema,
  updateResponseActionSchema,
  updateTriggerActionSchema,
  updateTriggerCaseActionSchema,
} from "./triggerActions/index.ts";

export const triggerActionSchemas = [
  addConditionActionSchema,
  addEffectActionSchema,
  addHandlerActionSchema,
  addResponseActionSchema,
  addTriggerActionSchema,
  addTriggerCaseActionSchema,
  moveConditionActionSchema,
  removeConditionActionSchema,
  removeEffectActionSchema,
  removeHandlerActionSchema,
  removeAllTriggersActionSchema,
  removeResponseActionSchema,
  removeTriggerActionSchema,
  removeTriggerCaseActionSchema,
  reorderConditionActionSchema,
  reorderEffectActionSchema,
  reorderHandlerActionSchema,
  reorderResponseActionSchema,
  reorderTriggerActionSchema,
  updateConditionConfigActionSchema,
  updateEffectConfigActionSchema,
  updateHandlerActionSchema,
  updateResponseActionSchema,
  updateTriggerActionSchema,
  updateTriggerCaseActionSchema,
] as const;

export const triggerActionSchema = z.discriminatedUnion("type", triggerActionSchemas);

export type TriggerAction = z.infer<typeof triggerActionSchema>;
